import type { NavLinkProps } from 'react-router-dom'

import { useMeQuery } from '../../../store/api'
import type { PlanPackageType } from '../../../store/types/billing'
import { useNavigateBillingModal } from '../../../utils/context/modal/use-navigate-billing-modal'
import ReloaderNavlink from '../reloader-navlink'

export default function PaymentRequiredLink({
  allowed,
  feature,
  ...props
}: NavLinkProps & {
  allowed: PlanPackageType[]
  feature: string
}): JSX.Element {
  const { data } = useMeQuery()
  const { open } = useNavigateBillingModal()

  return (
    <ReloaderNavlink
      {...props}
      onClick={(e) => {
        props?.onClick?.(e)
        if (data && data.package_type) {
          if (
            !allowed.includes(data.package_type) ||
            (data.package_type === 'S' && data.register_source !== 'Shopify')
          ) {
            e.preventDefault()
            open(feature)
          }
        }
      }}
    />
  )
}
